import {ITaskGet, IStatus, ITaskAddTag, ITaskApproval} from './../../interface/task/task'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'

export class GetTaskService extends Request {
  async request(options?: IPageOption, filter?: any) {
    try {
      const {data} = await this.client
        .post<IApiResponse<ITaskGet[]>>(
          `${API_PATH.TASK}/filter`,
          {
            ...filter,
            companyIds:
              filter.companyIds.length != 0 ? filter.companyIds.map((el) => el.id) : undefined,
            plantIds: filter.plantIds.length != 0 ? filter.plantIds.map((el) => el.id) : undefined,
          },
          {
            params: options,
          }
        )
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTaskByIdService extends Request {
  async request(id?: string, options?: IPageOption, tagNumber?: string, tagDescription?: string) {
    const queryString = new URLSearchParams(options as any).toString()
    try {
      const {data} = await this.client
        .post<IApiResponse<ITaskGet>>(`${API_PATH.TASK}/get-by-id/${id}?${queryString}`, {
          tagNumber,
          tagDescription,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTaskStatusService extends Request {
  async request(id?: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IStatus[]>>(`${API_PATH.TASK}/status`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class TaskAddTagService extends Request {
  async request(payload: ITaskAddTag) {
    try {
      const {data} = await this.client.patch<any>(`${API_PATH.TASK}/add-tag`, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class TaskEditTagService extends Request {
  async request(payload: ITaskAddTag) {
    try {
      const {data} = await this.client.patch<any>(`${API_PATH.TASK}/edit-tag`, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class TaskDeleteTagService extends Request {
  async request(payload: ITaskAddTag) {
    try {
      const {data} = await this.client.patch<any>(`${API_PATH.TASK}/delete-tag`, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class TaskApprovalService extends Request {
  async request(payload: ITaskApproval) {
    try {
      const {data} = await this.client.patch<any>(`${API_PATH.TASK}/approval`, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class TaskSubmitApprovalService extends Request {
  async request(taskId: string) {
    try {
      const {data} = await this.client.patch<any>(`${API_PATH.TASK}/submit-approval/${taskId}`)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTaskLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.TASK}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class ExportTagInTaskService extends Request {
  async request(taskId: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.TASK}/export-tags/${taskId}`, {})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
